import { DentalInsuranceReportTypes } from '@frontend/api-insurance-eligibility-report';
import { Benefit, BenefitLimit } from '../../../types/tuuthfairy-types';

export enum NetworkTypeEnum {
  IN_NETWORK = 'IN_NETWORK',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK',
}

export type DentalXChangeReportFilters = {
  selectedNetwork: NetworkTypeEnum;
  coverageLevel: string[];
};
export type TuuthFairyTableType = BenefitLimit & Partial<Benefit>;

export type TablesDataType = {
  activeCoverage?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  coInsurance?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  coPayment?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  deductible?: (DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo | TuuthFairyTableType)[];
  benefitDescription?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  exclusions?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  limitation?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  maximum?: (DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo | TuuthFairyTableType)[];
  notCovered?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  otherPayor?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  otherBenefit?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  outOfPocket?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
  otherSourceOfData?: DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo[];
};
//Below type has column keys of dentalxchange and tuuthfairy data
export type DentalXChangeTableColumnKey = keyof DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo;
export type TuuthFairyTableColumnKey = keyof TuuthFairyTableType;

export type TableColumnKeyType = DentalXChangeTableColumnKey | TuuthFairyTableColumnKey;
//Below type describes the table data based on vendor
export type TableDataType = DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo | TuuthFairyTableType;

export enum Vendors {
  DentalXChange = 'DentalXChange',
  TuuthFairy = 'TuuthFairy',
}

//This TableFilterKey can be network key from the object which contains in-network/out-of-network values
export type TableFilterKey =
  | keyof Pick<DentalInsuranceReportTypes.DentalXChangePlanBenefitInfo, 'network'>
  | keyof Pick<TuuthFairyTableType, 'networkType' | 'networkName'>;

export type TuuthFairyAndDXCTableKeyTypes = 'maximum' | 'deductible';

export type TableDataTypeExcludeTuuthFairy = Exclude<keyof TablesDataType, TuuthFairyAndDXCTableKeyTypes>;

export interface SegregatedDataByNetworkType {
  in_network: TablesDataType;
  out_network: TablesDataType;
}
